import * as actionTypes from './actionTypes';

const initialState = {
  PecuPrice: 0,
  USXMPrice: 1,
  auth_token: null,
  UserInfo: null,
  WalletInfo: null,
  isAdmin: false,
  cryptoData: [],
  projectTokens: [],
  wrapTokens: [],
  holdingTokens: [],
  liquidityPools: [],
  stocks: [],
  forex: [],
  commodities: [],
  derivatives: [],
  dat: [],
  synthetics: [],
  syntheticsPrice: [],
  deListed: [],
  syntheticsList: [
    'hETH',
    'hBNB',
    'hXRP',
    'hADA',
    'hDOGE',
    'hMATIC',
    'hSOL',
    'hDOT',
    'hAVAX',
    'hLTC',
    'hUNI',
    'hLINK',
    'hBCH',
    'hETC',
    'hBTC',
    'hBTX',
    'hLKX',
    'hDTX',
    'hDGX',
    'hMTX',
    'hXRX',
    'hAVX',
    'hBCX',
    'hBNX',
    'hECX',
    'hETX',
    'hLTX',
    'hSLX'
  ],
  derivativesList: [
    'hBNBBT',
    'hBNBET',
    'hBNBEU',
    'hBNBGB',
    'hBNBAU',
    'hBNBPT',
    'hBNBPD',
    'hPECUBT',
    'hPECUET',
    'hPECUGB',
    'hPECUEU',
    'hPECUAU',
    'hPECUPT',
    'hPECUPD',
    'hBTCEU',
    'hBTCGB',
    'hBTCAU',
    'hBTCPT',
    'hBTCPD',
    'hBTCWT',
    'hBTCBR',
    'hBTCET',
    'hLTCEU',
    'hLTCGB',
    'hLTCAU',
    'hLTCPT',
    'hLTCPD',
    'hLTCWT',
    'hLTCBR',
    'hLTCBT',
    'hLTCET',
    'hETHBT',
    'hETHBR',
    'hETHWT',
    'hETHPD',
    'hETHPT',
    'hETHAU',
    'hETHGB',
    'hETHEU',
    'hBJP',
    'hPJP',
    'hEJP',
    'hBTCH',
    'hECH',
    'hPCH',
    'hBHK',
    'hPHK',
    'hEHK',
    'hLHK',
    'hLJP',
    'hLCH',
    'hBCN',
    'hECN',
    'hLCN',
    'hPCN',
    'hBNZ',
    'hPNZ',
    'hENZ',
    'hLNZ',
    'hBAE',
    'hPAE',
    'hEAE',
    'hLAE',
    'hBJO',
    'hPJO',
    'hEJO',
    'hLJO',
    'hBIN',
    'hPIN',
    'hEIN',
    'hLIN',
    'hBSG',
    'hPSG',
    'hESG',
    'hLSG',
    'hBMX',
    'hPMX',
    'hEMX',
    'hLMX',
    'hBNO',
    'hPNO',
    'hENO',
    'hLNO',
    'hBSE',
    'hPSE',
    'hESE',
    'hLSE',
    'hBTW',
    'hPTW',
    'hETW',
    'hLTW',
    'hBHU',
    'hPHU',
    'hEHU',
    'hLHU',
    'hBTR',
    'hPTR',
    'hETR',
    'hLTR',
    'hBSA',
    'hPSA',
    'hESA',
    'hLSA',
    'hBEG',
    'hPEG',
    'hEEG',
    'hLEG',
    'hBGH',
    'hPGH',
    'hEGH',
    'hLGH',
    'hBUA',
    'hPUA',
    'hEUA',
    'hLUA',
    'hBPH',
    'hPPH',
    'hEPH',
    'hLPH',
    'hBMY',
    'hPMY',
    'hEMY',
    'hLMY',
    'hBKR',
    'hPKR',
    'hEKR',
    'hLKR',
    'hBID',
    'hPID',
    'hEID',
    'hLID',
    'hBIL',
    'hPIL',
    'hEIL',
    'hLIL',
    'hBTH',
    'hPTH',
    'hETTH',
    'hLTH',
    'hBPL',
    'hPPL',
    'hEPL',
    'hLPL'
  ],
  projectList: [
    'MMFx',
    'MLABx',
    'GYKRx',
    'LARSx',
    'MLRx',
    'BECKx',
    'PHARx',
    'DUMAx',
    'ALLEx'
  ],
  fanList: ['WOVx'],
  holdingList: ['MLABh', 'SPARh', 'NRLh', 'VSIOh', 'ARLNh', 'ISNOh', 'YUZUh'],
  tokenList: {},
  hedgeTokens: [
    'BTht',
    'SLht',
    'ETht',
    'PNht',
    'ETCht',
    'XMht',
    'BCht',
    'LKht',
    'UNht',
    'LTht',
    'AVht',
    'DTht',
    'MTht',
    'DGht',
    'ADht',
    'XRht',
    'BNht',
    'BGBht',
    'BEUht',
    'BAUht',
    'BPTht',
    'BPDht',
    'BWTht',
    'BBRht',
    'BETht',
    'PGBht',
    'PEUht',
    'PAUht',
    'PPTht',
    'PPDht',
    'EGBht',
    'EEUht',
    'EAUht',
    'EPDht',
    'EPTht',
    'EBRht',
    'EWTht',
    'EBTht',
    'BNGBht',
    'BNEUht',
    'BNAUht',
    'BNPTht',
    'BNPDht',
    'BNETht',
    'BNBTht',
    'LEUht',
    'LGBht',
    'LAUht',
    'LPTht',
    'LPDht',
    'LBRht',
    'LWTht',
    'LBTht',
    'LETht'
  ],
  dbtTokens: [
    'AATx',
    'BCTx',
    'GATx',
    'IRONx',
    'IDAx',
    'LANx',
    'NOBx',
    'PERx',
    'ROARx',
    'STORMx',
    'THUNx',
    'TDSTx',
    'TYTOx',
    'VALx',
    'WOLFx',
    'CLMBx',
    'FNETx',
    'MEXx',
    'BGRAx',
    'ALBAx',
    'BUBOx',
    'FINVx',
    'FSEAx',
    'FLTMx',
    'FNORx',
    'FEAx',
    'FMIDx'
  ],
  xmgTokens: ['PDXM', 'PTXM', 'AGXM', 'AUXM', 'USXM', 'WTXM', 'BRXM']
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.PECU_PRICE:
      return { ...state, PecuPrice: action.price };
    case actionTypes.USXM_PRICE:
      return { ...state, USXMPrice: action.price };
    case actionTypes.CRYPTO_DATA:
      return { ...state, CryptoData: action.cryptoData };
    case actionTypes.FETCH_HOLDING_TOKENS:
      return { ...state, holdingTokens: action.holdingTokens };
    case actionTypes.FETCH_PROJECT_TOKENS:
      return { ...state, projectTokens: action.projectTokens };
    case actionTypes.FETCH_WRAP_TOKENS:
      return { ...state, wrapTokens: action.wrapTokens };
    case actionTypes.FETCH_STOCKS:
      return { ...state, stocks: action.stocks };
    case actionTypes.FETCH_COMMODITY:
      return { ...state, commodities: action.commodities };
    case actionTypes.FETCH_FOREX:
      return { ...state, forex: action.forex };
    case actionTypes.FETCH_DERIVATIVES:
      return { ...state, derivatives: action.derivatives };
    case actionTypes.FETCH_DAT:
      return { ...state, dat: action.dat };
    case actionTypes.FETCH_SYNTHETICS:
      return { ...state, synthetics: action.synthetics };
    case actionTypes.FETCH_SYNTHETICS_PRICE:
      return { ...state, syntheticsPrice: action.syntheticsPrice };
    case actionTypes.FETCH_DELISTED_TOKENS:
      return { ...state, deListed: action.deListed };
    case actionTypes.FETCH_LIQUIDITY_POOLS:
      return { ...state, liquidityPools: action.liquidityPools };
    case actionTypes.FETCH_USER_INFO:
      return { ...state, UserInfo: action.UserInfo };
    case actionTypes.WALLET_INFO:
      return {
        ...state,
        WalletInfo: action.WalletInfo,
        auth_token: action.auth_token
      };
    case actionTypes.USER_INFO:
      return { ...state, UserInfo: action.UserInfo };
    case actionTypes.IS_ADMIN:
      return { ...state, isAdmin: action.isAdmin };
    case actionTypes.FETCH_TOKEN_LIST:
      return { ...state, tokenList: action.tokenList };
    default:
      return state;
  }
};

export default reducer;
